import * as React from 'react';

import { UserContext } from '../providers/UserProvider';
import { trackEvent } from '../analytics/tracking';
import DisplayLayer from '../common/DisplayLayer';
import SearchLocationInput from '../googlemaps/SearchLocationInput';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';

import PropTypes from 'prop-types';

import styles from './ServiceAddress.module.css';

/**
 * This component has 2 locations in the header: In the Nav, and under 1080px width on
 * a separate row under the nav
 * 
 * Currently, only anonymous users can update the address
 */
const ServiceAddress = ({
  inAddressBar,
  isPickup
}) => {
  
  const addressPlaceholder = 'Your Address';
  const { location, searchLocation, setSearchLocation } = React.useContext(UserContext);
  const [displayAddress, setDisplayAddress] = React.useState(addressPlaceholder);
  
  const [canUpdate, setCanUpdate] = React.useState();
  const [showAddressInput, setShowAddressInput] = React.useState();
  
  const handleShowInput = () => {
    setShowAddressInput(true);
    trackEvent('show_address_update');
  };

  React.useEffect(() => {
    /* logged in user */
    if(location?.street_address) {
      setDisplayAddress(location.street_address);
      setCanUpdate(false);
    } else if (searchLocation?.street_address) {
      setDisplayAddress(searchLocation.street_address);
      setCanUpdate(true);
    } else {
      setCanUpdate(true);
    }
  }, [location, searchLocation]);
  
  // Close address input on resize;
  React.useEffect(() => {
    const closeLayer = () => setShowAddressInput(false);
    window.addEventListener('resize', closeLayer);
    return () => window.removeEventListener('resize', closeLayer);
  }, []);

  // Style based on ability to update (logged in/out)
  const updateClass = canUpdate ? styles.updatable : '';
  // For tests and targeting individually in css
  const elemId = inAddressBar ? 'deliver_to_lower' : 'deliver_to_upper'; 

  return (
    <div className={styles.addressWrap}>
      
      <div id={elemId} className={`${styles.serviceAddress} ${updateClass}`}>
        <div className={styles.buttonStyle} onClick={canUpdate ? handleShowInput : ()=>{}}>
          { isPickup 
            ? <>Pickup<span className={styles.serviceAddressAlt}> near </span></>
            : <>Delivery<span className={styles.serviceAddressAlt}> to </span></>
          }
          <span className={styles.streetAddress}>{displayAddress || addressPlaceholder}</span>
          {/* Update only for anonymous users */}
          { canUpdate &&
            <ChevronRightRoundedIcon className={styles.updateArrow} />
          }
        </div>
      </div>
      
      {showAddressInput &&  
        <DisplayLayer closeFn={() => setShowAddressInput(false)}>
          <div className={styles.layerHeader}>
            Enter Your Address
          </div>
          <div className={styles.locationPin}>
            <LocationOnRoundedIcon />
          </div>
          <SearchLocationInput  placeholder="" label="Address" onSelection={
            (location) => {
              const {
                address:street_address,
                city,
                stateShort: state,
                zipCode: zip_code
              } = location;
              setSearchLocation({street_address, city, state, zip_code});
              setShowAddressInput(false);
          }} />
        </DisplayLayer>
      }
    </div> 
  );
};

ServiceAddress.propTypes = {
  inAddressBar: PropTypes.bool,
  isPickup: PropTypes.bool.isRequired
}

export default ServiceAddress;
